import files from './builtin-visualization-resources.json'

export function builtinResourceUrl (fileId) {
  const item = Object.prototype.hasOwnProperty.call(files, fileId) && files[fileId]
  return item ? '/jetlinks/visualization/resource/thumbnail/' + item.id + '/0' : ''
}

export function builtinComponentCover (resourceId) {
  const fileId = Object.keys(files).find(key => files[key].kind === 'component' && files[key].id === resourceId)
  return fileId ? builtinResourceUrl(fileId) : ''
}

export function matchesBuiltinImage (url, resourceId, fileId) {
  const item = Object.prototype.hasOwnProperty.call(files, fileId) && files[fileId]
  return !!item && item.kind === 'image' && item.id === resourceId && url === builtinResourceUrl(fileId)
}
